<template>
    <div>
        <!--Mobile Nav bar-->
        <div class="d-block d-md-none">
            <sidebar></sidebar>
        <!--Mobile Nav bar End-->


        <!--SideBar for Mobile-->
        <sidebar-toggle></sidebar-toggle>
        <!--SideBar for Mobile End-->
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Sidebar from "../utility/MenuSideBar/Sidebar";
    import SidebarToggle from "../utility/MenuSideBar/SidebarToggle";

    export default {
        name: "MobileLeftBar",
        components: {SidebarToggle, Sidebar },
        props: { },
        data () {
            return {}
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getDataOnLogin',
                'getUsername',
                'getMobileSideNavActive',
                'getInsideCurrentPage',
            ]),

            active: {
                get(){
                    // console.log('Getter ==>', this.getMobileSideNavActive)
                    return this.getMobileSideNavActive
                },
                set(active){
                    // console.log('Setter==>', this.getMobileSideNavActive)
                    this.updateMobileSideNavActive(active)
                }
            }
        },
        created () {},
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateDataOnLogin',
                'updateUsername',
                'updateSideBarPage',
                'updateCurrentComponent',
                'updateInsideCurrentPage',
                'updateIBankerList',
                'updateMoneyRequestSentList',
                'updateMoneyRequestReceivedList',
                'updateCurrentAirtimePhoneNo',
                'updateMobileSideNavActive',
            ]),


            switchSideNavActive(){
                // console.log('b4 manipulation ==>>', this.getMobileSideNavActive)
                this.updateMobileSideNavActive(true)

                // console.log('after manipulation ==>>', this.getMobileSideNavActive)
            },
            testSwitch(){
                // console.log('--TEST--b4 manipulation ==>>', this.getMobileSideNavActive)

                this.updateMobileSideNavActive(false)

                // console.log('--TEST--after manipulation ==>>', this.getMobileSideNavActive)
            },
            closeMobileSidebar(){
                // console.log('Close Side Bar')

                // this.active= false;
                this.updateMobileSideNavActive(false);

                // console.log('Changed Active ==>', this.active)
            },
            goToDashboard(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('dashboard');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('dashboard')
                }, 500);
            },
            goToSendMoney(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    // console.log('Current side bar value ==>>', this.getMobileSideNavActive)
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('send-money');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('sendMoney')

                }, 500);
            },
            goToPayBills(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('pay-bills');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('payBills')
                }, 500);
            },
            goToBuyAirtime(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    // update current airtime phone number
                    this.updateCurrentAirtimePhoneNo([this.getDataOnLogin.countrycode, '0'+this.getDataOnLogin.mobilenumber])

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('airtime')
                }, 500);
            },
            goToAllAccounts(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('all-accounts');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('allAccount')
                }, 500);
            },
            goToIndependentBanker(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    //start app loading
                    this.updateAppLoading(true);

                    let bodyToSend = {
                        customerid: this.getDataOnLogin.customerid,
                    }

                    axios
                        .post('/mybankercustomers', bodyToSend,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData =  response.data;

                            // console.log('responseData ==>>', responseData)

                            if (responseData.responsecode === '00') {
                                this.updateIBankerList (responseData.result);

                                //update "sideBarPage" in the store
                                this.updateSideBarPage('independent-banker');

                                //Update the current sub component in the store
                                this.updateInsideCurrentPage('independentBanker')

                            } else {

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // log Error
                            // console.log(error);
                        })
                }, 500);
            },
            goToMoneyRequest(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    //start app loading
                    this.updateAppLoading(true);


                    let bodyToSend = {
                        username: this.getUsername
                    }

                    axios
                        .post('/requestmoneysentlist', bodyToSend,
                            {
                                headers : {
                                    'Authorization': this.getDataOnLogin.authorization,
                                    'Content-Type': 'application/json',
                                    'Access-Control-Allow-Origin': '*'
                                }})
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData =  response.data;

                            // console.log('responseData ===>>', responseData)


                            if (responseData.responsecode === '00') {

                                this.updateMoneyRequestSentList(responseData.result)

                                axios
                                    .post('/requestmoneyreceivedlist', bodyToSend,
                                        {
                                            headers : {
                                                'Authorization': this.getDataOnLogin.authorization,
                                                'Content-Type': 'application/json',
                                                'Access-Control-Allow-Origin': '*'
                                            }})
                                    .then(response2 => {
                                        //stop app running
                                        this.updateAppLoading(false);

                                        let responseData2 =  response2.data;

                                        // console.log('responseData2 ==>>', responseData2)

                                        if (responseData2.responsecode === '00') {
                                            this.updateMoneyRequestReceivedList(responseData2.result)

                                            //update "sideBarPage" in the store
                                            this.updateSideBarPage('money-request');

                                            //Update the current sub component in the store
                                            this.updateInsideCurrentPage('moneyRequest')
                                        } else {
                                            // display error notification
                                            this.showAlert(true, 'error', responseData.responsemessage)
                                        }
                                    })
                                    .catch(error => {
                                        //stop app running
                                        this.updateAppLoading(false);

                                        // log Error
                                        // console.log(error);
                                    })
                            } else {

                                // display error notification
                                this.showAlert(true, 'error', responseData.responsemessage)
                            }
                        })
                        .catch(error => {
                            //stop app running
                            this.updateAppLoading(false);

                            // log Error
                            // console.log('--------Error----', error ,'----Error--------');

                            // set network error state to true
                            this.updateNetworkErrorState(true);
                        })
                }, 500);
            },
            goToAccountStatement(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    //update "sideBarPage" in the store
                    this.updateSideBarPage('account-statement');

                    //Update the current sub component in the store
                    this.updateInsideCurrentPage('accountStatement')
                }, 500);
            },
            goToSignOut(){
                //close the mobile side nav
                this.updateMobileSideNavActive(false)
                setTimeout(()=>{
                    //
                    //start app loading
                    this.updateAppLoading(true);

                    axios
                        .post('/logout', {
                            username: this.getUsername
                        })
                        .then(response => {
                            //stop app running
                            this.updateAppLoading(false);

                            let responseData = response.data;

                            if (responseData.responsecode === '00'){
                                this.actualLogout()
                            }
                        })
                        .catch(error => {
                            // console.log('Alt Log out');

                            this.actualLogout()
                        })
                }, 500);
            },

            actualLogout(){
                // reset the data on login to an empty string
                this.updateDataOnLogin('');
                this.updateUsername('');

                //redirect to the login page
                this.updateCurrentComponent('login')
            },
        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>
.mobile-sidebar-close{
    cursor: pointer;
    position: absolute;
    top: 15px;
    right: 20px;
    z-index: 999;
}
.mobile-sidebar-close svg{
    height: 25px;
    width: 25px;
}
</style>